<template>
    <div>
        <b-modal 
            id="popupModal" 
            v-bind:title="title" 
            v-model="modalShow"
            @show="modalShowFunc"
            @hidden="modalHideFunc"
            @ok="okFunc"
            v-bind:no-close-on-backdrop="isBackDrop">
            <component :is="componentType" ref="view">
            </component>
            <div slot="modal-footer" class="btnBox">
                <b-btn class="redBtn fixWdBtn" @click="okFunc">등 록</b-btn>
                <b-btn class="redborderBtn fixWdBtn" @click="closeFunc">취 소</b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'PopupModal',
    data() {
        return {
            modalShow: false,
            componentType : null
        }
    },
    watch: {
        modalShow: function (val) {
            if(val === true){
                this.componentType = () => import(`@/${this.$store.state.modal.url}`)
            }
        }
    },
    computed : {
        ...mapState("modal", ["title", "url", "paramDatas", "isBackDrop"])
    },
    methods:{
        modalShowFunc(){
            
        },
        modalHideFunc(){
            
        },
        okFunc(bvModalEvt){
            let state = this.$store.state.modal.state;
            if(state === "VIEW"){
                if(this.$refs.view.doOkFunc != null){
                    this.$refs.view.doOkFunc();
                }
            } else if(state === "MOD"){
                bvModalEvt.preventDefault()
                this.$refs.view.handleSubmit();
            }
            
        },
        closeFunc(){
            this.$bvModal.hide('popupModal');
        },
    }
}
</script>